if (!customElements.get('pdp-tabs')) {
  class PdpTabs extends HTMLElement {
    connectedCallback() {
      this._navEl = this.querySelector('[role="tablist"]');
      this._panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this._buttons = this._navEl ? Array.from(this._navEl.querySelectorAll('[role="tab"]')) : [];

      if (!this._navEl || !this._buttons.length) return;

      this._navEl.addEventListener('click', (event) => {
        const btn = event.target.closest('[role="tab"]');
        if (!btn) return;
        this._activate(btn);
      });

      this._navEl.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const idx = this._buttons.indexOf(document.activeElement);
        let next = idx;
        if (event.key === 'ArrowRight') next = (idx + 1) % this._buttons.length;
        if (event.key === 'ArrowLeft') next = (idx - 1 + this._buttons.length) % this._buttons.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this._buttons.length - 1;
        this._activate(this._buttons[next]);
        this._buttons[next].focus();
      });
    }

    _activate(btn) {
      this._buttons.forEach((b) => {
        b.setAttribute('aria-selected', 'false');
        b.classList.remove('is-active');
      });

      btn.setAttribute('aria-selected', 'true');
      btn.classList.add('is-active');

      const panelId = btn.getAttribute('aria-controls');
      this._panels.forEach((panel) => {
        if (!panel.hidden && panel.id !== panelId) {
          const videos = panel.querySelectorAll('video');
          const anyPlaying = Array.from(videos).some((v) => !v.paused);
          if (anyPlaying) {
            videos.forEach((v) => v.pause());
            const embed = panel.querySelector('[data-video-embed]');
            const preview = panel.querySelector('[data-video-preview]');
            if (embed && preview) {
              embed.hidden = true;
              preview.hidden = false;
            }
          }
        }
        panel.hidden = panel.id !== panelId;
      });

      if (btn.dataset.tab === 'face-map') {
        const activePanel = this._panels.find((p) => p.id === panelId);
        if (!activePanel) return;
        const hint = activePanel.querySelector('.section-pdp-ingredient-science-zone-hint');
        if (!hint) return;
        clearTimeout(hint._hintTimer);
        hint.classList.add('is-visible');
        hint._hintTimer = setTimeout(() => hint.classList.remove('is-visible'), 20000);
      }
    }
  }

  customElements.define('pdp-tabs', PdpTabs);
}

if (!customElements.get('pdp-face-map')) {
  class PdpFaceMap extends HTMLElement {
    connectedCallback() {
      this._triggers = Array.from(this.querySelectorAll('[data-zone-trigger]'));
      this._tooltips = Array.from(this.querySelectorAll('[data-zone-trigger] .section-pdp-ingredient-science-zone-tooltip'));

      if (!this._triggers.length) return;

      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-zone-trigger]');
        if (!trigger) return;
        this._activate(trigger.dataset.zoneTrigger);
      });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const trigger = event.target.closest('[data-zone-trigger]');
        if (!trigger) return;
        event.preventDefault();
        this._activate(trigger.dataset.zoneTrigger);
      });
    }

    _activate(zoneId) {
      this._triggers.forEach((trigger) => {
        const isActive = trigger.dataset.zoneTrigger === zoneId;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-pressed', String(isActive));

        const tooltip = trigger.querySelector('.section-pdp-ingredient-science-zone-tooltip');
        if (!tooltip) return;

        tooltip.style.top = '';
        tooltip.style.bottom = '';
        tooltip.style.left = '';
        tooltip.style.right = '';
        tooltip.style.transform = '';
        tooltip.classList.toggle('is-active', isActive);

        if (isActive) this._smartPosition(tooltip);
      });
    }

    _smartPosition(tooltip) {
      const containerRect = this.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();

      if (tooltipRect.bottom > containerRect.bottom - 4) {
        tooltip.style.top = 'auto';
        tooltip.style.bottom = 'calc(100% + 8px)';
      }

      if (tooltipRect.right > containerRect.right - 4) {
        tooltip.style.left = 'auto';
        tooltip.style.right = '0';
        tooltip.style.transform = 'none';
      }

      if (tooltipRect.left < containerRect.left + 4) {
        tooltip.style.left = '0';
        tooltip.style.right = 'auto';
        tooltip.style.transform = 'none';
      }
    }
  }

  customElements.define('pdp-face-map', PdpFaceMap);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.section-pdp-ingredient-science-inci').forEach((details) => {
    const summary = details.querySelector('.section-pdp-ingredient-science-inci-toggle');
    const content = details.querySelector('.section-pdp-ingredient-science-inci-content');
    if (!summary || !content) return;

    content.style.height = details.open ? content.scrollHeight + 'px' : '0px';

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      if (details.open) {
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0px';
        });
        content.addEventListener('transitionend', () => {
          details.removeAttribute('open');
        }, { once: true });
      } else {
        details.setAttribute('open', '');
        const target = content.scrollHeight;
        content.style.height = '0px';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            content.style.height = target + 'px';
          });
        });
        content.addEventListener('transitionend', () => {
          content.style.height = 'auto';
        }, { once: true });
      }
    });
  });

  document.querySelectorAll('[data-video-play]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = btn.closest('[data-video-panel]');
      if (!panel) return;

      const preview = panel.querySelector('[data-video-preview]');
      const embed = panel.querySelector('[data-video-embed]');
      if (!embed) return;

      if (preview) preview.hidden = true;
      embed.hidden = false;

      const wrappers = embed.querySelectorAll(
        '.section-pdp-ingredient-science-video--desktop, .section-pdp-ingredient-science-video--mobile'
      );
      let video = null;
      for (const wrapper of wrappers) {
        if (getComputedStyle(wrapper).display !== 'none') {
          video = wrapper.querySelector('video');
          break;
        }
      }
      if (video) {
        attachVideoHandlers(video);
        video.play().catch(() => {});
      }
    });
  });

  function attachVideoHandlers(video) {
    if (video._handlersAttached) return;
    video._handlersAttached = true;

    const savedOverflows = [];
    let isFullscreen = false;

    const clearClipping = () => {
      if (savedOverflows.length > 0) return;
      let el = video.parentElement;
      while (el && el !== document.body) {
        const computed = getComputedStyle(el);
        if (computed.overflow === 'hidden' || computed.overflowX === 'hidden' || computed.overflowY === 'hidden') {
          savedOverflows.push({ el, overflow: el.style.overflow, overflowX: el.style.overflowX, overflowY: el.style.overflowY });
          el.style.overflow = 'visible';
        }
        el = el.parentElement;
      }
      document.documentElement.style.overscrollBehavior = 'none';
    };

    const restoreClipping = () => {
      savedOverflows.splice(0).forEach(({ el, overflow, overflowX, overflowY }) => {
        el.style.overflow = overflow;
        el.style.overflowX = overflowX;
        el.style.overflowY = overflowY;
      });
      document.documentElement.style.overscrollBehavior = '';
    };

    const update = () => {
      if (!video.paused || isFullscreen) {
        clearClipping();
      } else {
        restoreClipping();
      }
    };

    video.addEventListener('play', update);
    video.addEventListener('pause', update);
    video.addEventListener('ended', update);
    video.addEventListener('webkitbeginfullscreen', () => { isFullscreen = true; update(); });
    video.addEventListener('webkitendfullscreen', () => { isFullscreen = false; update(); });
    video.addEventListener('fullscreenchange', () => { isFullscreen = document.fullscreenElement === video; update(); });
  }

  document.querySelectorAll('.section-pdp-ingredient-science-mode-tabs').forEach((tabList) => {
    const panel = tabList.closest('.section-pdp-ingredient-science-tab-panel');
    if (!panel) return;

    tabList.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-mode-tab]');
      if (!btn) return;

      const idx = btn.dataset.modeTab;

      tabList.querySelectorAll('[data-mode-tab]').forEach((b) => {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', String(b === btn));
      });

      panel.querySelectorAll('[data-step-set]').forEach((set) => {
        set.classList.toggle('is-active', set.dataset.stepSet === idx);
      });
    });
  });
});
